import { defineComponent as _defineComponent } from 'vue';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { VContainer, VRow, VCol } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosProgressCircularDemo',
    setup(__props) {
        const progressValue = ref(0);
        let interval;
        onMounted(() => {
            interval = setInterval(() => {
                progressValue.value = (progressValue.value + 10) % 110;
            }, 1000);
        });
        onBeforeUnmount(() => {
            clearInterval(interval);
        });
        return { __sfc: true, progressValue, interval, VContainer, VRow, VCol, CodePreview, DemoSection };
    }
});
